import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-link",
  "use": "arrow-link-usage",
  "viewBox": "0 0 35 35",
  "content": "<symbol viewBox=\"0 0 35 35\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-link\">\n<path d=\"M34.2852 16.7136L32.8709 18.1278L20.143 5.39991L20.143 2.57149L34.2852 16.7136Z\" />\n<path d=\"M20 16.5715L20 18.5715L1 18.5715L1 16.5715L20 16.5715Z\" />\n<path d=\"M30.043 18.1279L31.4572 19.5421L20.1435 30.8559L20.1435 28.0274L30.043 18.1279Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol